import { t } from "/global/js/translations.min.js?v=1741158023";
export default class MailChimp {
  constructor(id) {
    this.id = id;
    this.module = document.querySelector("#" + this.id);
    this.module.style.minHeight = '100px';
    this.parent = this.module.parentNode;
    this.settings = JSON.parse(decodeURIComponent(this.parent.dataset.settings));
    this.ajaxHandler = '/global/ajaxHandlerGlobal.php';
    (async () => {
      this.t = await t;
      this.render();
      this.form = this.module.querySelector('form');
      this.form.addEventListener('submit', e => this.formSubmit(e));
      this.successMessage = this.settings?.subscribeSuccessMessage ? this.settings.subscribeSuccessMessage : this.t.__("Thank you for signing up");
      this.errorMessage = this.settings?.subscribeErrorMessage ? this.settings.subscribeErrorMessage : this.t.__("Unfortunately, we could not add you to the subscription right now. Try again later");
    })();
  }
  render() {
    let name = '';
    let dob = '';
    if (this.settings?.subscribeShowName === '1' || this.settings?.subscribeShowName === '2') {
      name = `
                <div class="mb-3">
                    <div class="input-group">
                        <span class="input-group-text"><i class="fa-light fa-user"></i></span>
                        <input type="text" id="subscribeFirstName" class="form-control" name="firstName" placeholder="${this.t.__('First name')}" aria-label="${this.t.__('First name')}" autocomplete="given-name" ${this.settings?.subscribeShowName === '2' ? 'required' : ''}>
                        <input type="text" id="subscribeLastName" class="form-control" name="lastName" placeholder="${this.t.__('Last name')}" aria-label="${this.t.__('Last name')}" autocomplete="family-name" ${this.settings?.subscribeShowName === '2' ? 'required' : ''}>
                    </div>
                </div>
            `;
    }
    if (this.settings?.subscribeShowBirthday === '1' || this.settings?.subscribeShowBirthday === '2') {
      dob = `
                <div class="mb-3">
                    <div class="input-group">
                        <span class="input-group-text"><i class="fa-light fa-calendar"></i></span>
                        <input type="date" id="subscribeDob" class="form-control" name="birthday" placeholder="${this.t.__('Birthday')}" aria-label="${this.t.__('Birthday')}" ${this.settings?.subscribeShowBirthday === '2' ? 'required' : ''}>
                    </div>
                </div>
            `;
    }
    this.module.innerHTML = `
            <form>
                <div class="row">
                    <div class="mb-3">
                        ${this.settings?.subscribeHeadline ? `<h4 class="mb-1">${this.settings.subscribeHeadline}</h4>` : ''}
                        ${this.settings?.subscribeDescription ? `<div>${this.settings.subscribeDescription}</div>` : ''}
                    </div>
                    
                    ${name}
                    
                    ${dob}
                    
                    <div class="mb-3">
                        <div class="input-group">
                            <span class="input-group-text"><i class="fa-light fa-envelope"></i></span>
                            <input type="email" id="subscribeEmail" class="form-control" name="subscriptionEmail" placeholder="${this.t.__('Email')}" aria-label="${this.t.__('Email')}" autocomplete="email" required>
                        </div>
                    </div>
                    
                    <div class="mb-3">
                        <button type="submit" class="w-100 btn ${this.settings?.subscribeSubmitButtonColor ? this.settings.subscribeSubmitButtonColor : 'btn-primary'}">
                            ${this.settings?.subscribeSubmitText ? this.settings.subscribeSubmitText : this.t.__('Submit')}
                        </button>
                    </div>
                </div>
            </form>
        `;
    if (dob) {
      const fp = window.initFlatpickrs();
      fp.flatpickrDate[0].set("dateFormat", "m/d");
    }
  }
  formSubmit(e) {
    e.preventDefault();
    const formData = new FormData(this.form);
    formData.append('subscribeList', this.settings?.subscribeList);
    formData.append('subscribeStatus', this.settings?.subscribeStatus);
    formData.append('ajaxToken', window.ajaxToken);
    grecaptcha.ready(async () => {
      const token = await grecaptcha.execute(window.siteKey, {
        action: 'submit'
      });
      formData.append('g-recaptcha-response', token);
      const request = await fetch('/content/plugins/mailChimp/ajaxHandlerMailChimp.php?handler=addEmailToList', {
        method: 'POST',
        body: formData
      });
      const response = await request.json();
      if (response.error) {
        pubsub.trigger('error', {
          errorMsg: this.errorMessage
        });
        return;
      }
      pubsub.trigger('success', {
        successMsg: this.successMessage
      });
    });
  }
}